import { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./Fullscreen_Success_Modal.css";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

const Fullscreen_Success_Modal = ({ lottie, message, ...props }) => {
  return (
    <>
      <Modal
        {...props}
        fullscreen
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Fullscreen_Success_Modal"
      >
        <div className="container">
          <Modal.Body>
            <div className="full_modal">
            <div className="success_content_div">
              <div className="success_card">
                <div className="lottie_hold">{lottie}</div>
                <p className="success_text">{message}</p>
              </div>
            </div>
            </div>
            

          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default Fullscreen_Success_Modal;
